import React from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Row } from "reactstrap";

const PricingSection = ({ data }) => {
  const location = useLocation();
  const pathName = location.pathname;
  const { darkMode } = useSelector((state) => state.global);
  return (
    <Row
      className={`d-flex flex-column my-4  px-4 ${
        pathName === "/tracking" && darkMode
          ? "bg-transparent mt-3"
          : darkMode
          ? "bg-site-black mt-3"
          : "bg-site-white mt-3"
      }`}
    >
      <div className="d-flex py-2 justify-content-between align-items-center">
        <span className={darkMode ? "normal-heading-dark" : "text-muted"}>
          Order Price
        </span>
        <span className={darkMode ? "normal-heading-dark" : "text-muted"}>
          {data?.currency || "$"} {data?.basePrice}
        </span>
      </div>

      {data?.appliedCharges && data?.appliedCharges?.length > 0 && (
        <div className="d-flex flex-column py-2">
          {data?.appliedCharges?.map((charge, index) => (
            <div
              key={index}
              className="d-flex justify-content-between align-items-center mb-2"
            >
              <span className={darkMode ? "normal-heading-dark" : "text-muted"}>
                {charge.name} (
                {charge.type === "fixed"
                  ? `${data?.currency} ${charge.fee}`
                  : `${charge.fee}%`}
                )
              </span>
              <span className={darkMode ? "normal-heading-dark" : "text-muted"}>
                + {data?.currency} {charge.addedAmount}
              </span>
            </div>
          ))}
        </div>
      )}

      <div className="d-flex py-3 justify-content-between align-items-center cart__shipping_pricing border-top mt-2 pt-2">
        <h5 className={darkMode ? "normal-heading-dark" : "price_heading"}>
          Total Price
        </h5>
        <h5
          className={
            darkMode ? "fs--18 fw--600 normal-heading-dark" : "fs--18 fw--600"
          }
        >
          {data?.currency || "$"}{" "}
          <span className="text-success">{data?.finalPrice}</span>
        </h5>
      </div>
    </Row>
  );
};

export default PricingSection;
